import { m } from 'framer-motion';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { usePathname } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';
// _mock
import { _socials } from 'src/_mock';
import Iconify from 'src/components/iconify';
// theme
import { textGradient, bgGradient } from 'src/theme/css';
import Logo from 'src/assets/logo.png';

// ----------------------------------------------------------------------
const LINKS = [
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Condition', href: 'http://deavnet.com/privacypolicy.pdf' },
      { name: 'Privacy Policy', href: 'http://deavnet.com/tc.pdf' },
    ],
  },
  {
    headline: 'Contact',
    children: [{ name: 'support@deavnet.com', href: '#' }],
  },
];

export default function Footer() {
  const pathname = usePathname();
  const theme = useTheme();


  const isHome = pathname === '/';

  const simpleFooter = (
    <Box
      component="footer"
      sx={{
        py: 5,
        textAlign: 'center',
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Container>
        <Box mb={1}><img src={Logo} style={{ width: '200px' }} alt="logo" /></Box>

        <Typography variant="caption" component="div">
          © All rights reserved
          <br /> made by
          <Link href="http://deavnet.com"> Deavnet Solutions </Link>
        </Typography>
      </Container>
    </Box>
  );

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.default',

        ...bgGradient({
          color: alpha(theme.palette.background.default, 0.8),
          imgUrl: '/assets/background/overlay_4.jpg',
        }),
      }}
    >
      <Divider />

      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <Box mb={3}><img src={Logo} style={{ width: '200px' }} alt="logo" /></Box>

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={8} md={3}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 400,
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              <b>Visit us:</b> Rutumbhara Pradnya, Siddhi-Vinayak Society, Saswad-Sonori Road, Saswad, 412301, Maharashtra
            </Typography>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 400,
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              <b>Call us:</b> +91 9370467763, +91 9545103282
            </Typography>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 400,
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              <b>Talk to us:</b> support@deavnet.com
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 3,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <IconButton
                  key={social.name}
                  sx={{
                    '&:hover': {
                      bgcolor: alpha(social.color, 0.08),
                    },
                  }}
                >
                  <Iconify color={social.color} icon={social.icon} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid xs={12} md={6}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }}>
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      component={RouterLink}
                      href={link.href}
                      color="inherit"
                      variant="body2"
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          © 2021. All rights reserved
        </Typography>
      </Container>
    </Box>
  );

  return isHome ? simpleFooter : mainFooter;
}
